import { useMountEffect } from "@react-hookz/web";
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { Container } from "./styles";
export const GroupSubscriberTooltip = ({
  message,
  onImpression
}) => {
  const {
    currentRoute,
    handleTrackGA
  } = useSdkContext();
  useMountEffect(() => {
    onImpression();
    handleTrackGA({
      action: "My Account/Hint/Group Subscription Benefits/Impression",
      category: "My Account",
      label: currentRoute
    });
  });
  return /*#__PURE__*/React.createElement(Container, {
    dangerouslySetInnerHTML: {
      __html: message
    },
    "data-qa": "group-subscriber-tooltip"
  });
};
GroupSubscriberTooltip.displayName = "GroupSubscriberTooltip";